module.exports = __webpack_public_path__ + "img/ctrl-swap-theta-stub--i.f4c834f3.svg";